import React from "react";
import DefaultLayout from "./layouts/DefautlLayout";

const App = () => {
  return <DefaultLayout />;
};

export default App;
